import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/styles'
import {Typography} from "@material-ui/core"
import {useDropzone} from 'react-dropzone'
import {Field} from "react-final-form"
import __ from "../../../../LanguageHelper"
import BackupIcon from '@material-ui/icons/Backup'
import _ from 'lodash'

const useStyles = makeStyles((theme) => ({
  field: {},
  input: {
    display: 'none',
  },
  filename: {
    marginTop: theme.spacing(1)
  },
  img: {
    maxWidth: 120,
    maxHeight: 120,
    display: 'block',
    width: 'auto',
    height: '100%'
  },
  image_container: {
    marginBottom: theme.spacing(1)
  },
  thumb: {
    display: 'inline-flex',
    marginTop: 8,
    marginBottom: 8,
    marginRight: 8,
    width: 40,
    height: 40,
    borderRadius: 5,
    boxSizing: 'border-box',
    textAlign: 'center'
  },
  dropZone: {
    display: "flex",
    width: "100%",
    border: "1px dashed #afafaf",
    height: 90,
    alignItems: "center",
    borderRadius: 10,
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    color: "#afafaf",
    outline: 'none',
    flexDirection: 'column'
  },
  container: {
    marginTop: 5
  },
  filesContainer: {
    display: "flex",
    flexDirection: 'row',
    backgroundColor: "#f5f5f5",
    paddingRight: 10,
    paddingLeft: 10,
    borderRadius: 5,
    marginLeft: 1,
    marginBottom: 1,
  },
  fileDetails: {
    paddingTop: 10,
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  selectedFiles: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 7,
  },
  fileThumb: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: 40,
    height: 40,
    marginTop: 8,
    marginBottom: 8,
    borderRadius: 5,
    marginRight: 8,
    fontSize: 13,
    fontFamily: 'tahoma'
  }
}))

function humanFileSize(bytes, si = true) {
  let u, b = bytes, t = si ? 1000 : 1024;
  ['', si ? 'k' : 'K', ...'MGTPEZY'].find(x => (u = x, b /= t, b ** 2 < 1))
  return `${u ? (t * b).toFixed(1) : bytes} ${u}B`
}

function getExtension(name) {
  let re = /(?:\.([^.]+))?$/
  return re.exec(name)[1]
}

function getFileName(file) {
  return file.match(/^.*?([^\\/.]*)[^\\/]*$/)[1];
}

const DropZone = ({field, title, onChange, value, multiple, size, full, type, fileType}) => {
  const classes = useStyles()
  const [files, setFiles] = useState([])
  const [error, setError] = useState(false)

  const maxSize = size * 1000

  const {getRootProps, getInputProps} = useDropzone({
    accept: type === 'image' ? 'image/*' : fileType,
    multiple,
    maxSize,
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => {
        let fileType = file.type.split('/')[0]
        return Object.assign(file, {
          fileType,
          ext: getExtension(file.name),
          preview: URL.createObjectURL(file)
        })
      }))

      onChange(acceptedFiles)
      setError(false)
    },
    onDropRejected: () => {
      setError(true)
    }
  })

  const uploadedFiles = () => {
    return _.isString(value) ? [value] : value
  }

  return (
    <>
      <Typography variant="body1">{title}</Typography>

      <section className={classes.container}>
        <div {...getRootProps({className: classes.dropZone})}>
          <input {...getInputProps()} />

          <BackupIcon fontSize={'large'}/>
          <Typography variant={'body1'}>{__('اسحب الملفات هنا أو تصفح', "Drag files here or Browse")}</Typography>
          <Typography variant={'caption'}>{__(`أقصي حجم للملف ${humanFileSize(maxSize)}`, `Allowed size ${humanFileSize(maxSize)}`)}</Typography>
        </div>


        {error && <Typography variant={'body2'} style={{color: '#d50000', fontSize: 11, textAlign: 'center', marginTop: 5}}>{__('بعض الملفات اكبر من الحد الاقصى للحجم', 'Some files are larger than maximum size')}</Typography>}

        {files.length > 0 && <div className={classes.selectedFiles}>
          {files.map(file => (
            <div className={classes.filesContainer} style={{width: full ? '100%' : 'calc(50% - 2px)'}}>
              {file.fileType === "image" ? <img alt={title} src={file.preview} className={classes.thumb}/> : <div className={classes.fileThumb}>{file.ext}</div>}

              <div className={classes.fileDetails}>
                <Typography noWrap variant={'caption'}>{file.name}</Typography>
                <Typography variant={'body2'}>{humanFileSize(file.size)}</Typography>
              </div>
            </div>
          ))}
        </div>}

        {(files.length === 0 && value) && <div className={classes.selectedFiles}>
          {uploadedFiles().map(file => (
            <div className={classes.filesContainer} style={{width: full ? '100%' : 'calc(50% - 2px)'}}>
              {['jpg', 'jpeg', 'png', 'gif', 'ico'].includes(getExtension(value)) ? <img src={file} alt={title} className={classes.thumb}/> : <div className={classes.fileThumb}>{getExtension(value)}</div>}

              <div className={classes.fileDetails}>
                <Typography variant={'caption'}>{getFileName(file)}</Typography>
              </div>
            </div>
          ))}
        </div>}
      </section>
    </>
  )
}

const FormUpload = ({field, title, value, size = 200, multiple = false, full, type, fileType}) => {
  return (
    <>
      <Field name={field}>
        {props => (
          <div>
            <DropZone {...props.input} size={size} multiple={multiple} full={full} type={type} fileType={fileType} title={title} value={value}/>
          </div>
        )}
      </Field>
    </>
  )
}

FormUpload.propTypes = {
  field: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.any,
}

export default FormUpload
